import { ModulesConfigMap, ModulesMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getWorksProductivityNorms: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].GET_WORKS_PRODUCTIVITY_NORMS,
	},
	getBasedWorksProductivityNorms: {
		useCache: true,
		cacheStorage: STORE_MAP.BASE,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].GET_WORKS_PRODUCTIVITY_NORMS,
	},
	getExtendedWorksProductivityNorms: {
		useCache: true,
		cacheStorage: STORE_MAP.EXTENDED,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].GET_WORKS_PRODUCTIVITY_NORMS,
	},
	getWorksProductivityNorm: {
		useCache: true,
		isSingleCachedEntity: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].GET_WORKS_PRODUCTIVITY_NORM,
	},
	createWorksProductivityNorm: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].CREATE_WORKS_PRODUCTIVITY_NORM,
	},
	putWorksProductivityNorm: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].PUT_WORKS_PRODUCTIVITY_NORM,
	},
	patchWorksProductivityNorm: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].PATCH_WORKS_PRODUCTIVITY_NORM,
	},
	deleteWorksProductivityNorm: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].DELETE_WORKS_PRODUCTIVITY_NORM,
	},
}
